import axios from "axios";

const baseUrl = process.env.VUE_APP_API_BASE_URL.replace(/\/v1\/?$/, "");
const url = `${baseUrl}/elixio-connect`;

async function getModules() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.get(`${url}/modules`, options);
}

async function getAllServices(organisationId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.get(`${url}/services`, options);
}

async function refreshService(organisationId, serviceId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.get(`${url}/services/${serviceId}`, options);
}

async function subscribe(organisationId, data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.post(`${url}/subscribe`, data, options);
}

async function toggleServiceActivation(organisationId, data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.post(`${url}/toggle-service-activation`, data, options);
}

async function updateConfigs(organisationId, data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.post(`${url}/update-configs`, data, options);
}

async function syncBatch(organisationId, service_type, created_after = null) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.post(
    `${url}/batch`,
    { created_after, service_type },
    options
  );
}

async function getBatch(organisationId, batchId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: {
      holder_type: "Organization",
      holder_id: organisationId,
    },
  };

  return await axios.get(`${url}/batch/${batchId}`, options);
}

// All Shipments
async function getAllShipments(params) {
  console.log(params);
  const options = {
    params: params,
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.get(`${url}/shipments`, options);
}

// Shipments
async function getShipments(shippableType, shippableId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.get(
    `${url}/shipments/${shippableType}/${shippableId}`,
    options
  );
}

async function getShipment(shipmentId, serviceId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.get(
    `${url}/shipments/show/${shipmentId}/${serviceId}`,
    options
  );
}

async function estimateShipment(shippableType, shippableId, data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(
    `${url}/shipments/${shippableType}/${shippableId}/estimate`,
    data,
    options
  );
}

async function editEstimation(shipmentId, data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(
    `${url}/shipments/${shipmentId}/edit-estimation`,
    data,
    options
  );
}

function destroyEstimation(shipmentId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/shipments/${shipmentId}`, options);
}

async function createShipment(shipmentId, serviceId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(
    `${url}/shipments/${shipmentId}/create`,
    {
      service_id: serviceId,
    },
    options
  );
}

async function createPickup(shipmentId, pickupDetails) {
  console.log(pickupDetails);
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(
    `${url}/shipments/${shipmentId}/pickup`,
    pickupDetails,
    options
  );
}

async function cancelShipment(shipmentId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(`${url}/shipments/${shipmentId}/cancel`, {}, options);
}

async function cancelPickup(shipmentId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(
    `${url}/shipments/${shipmentId}/cancel-pickup`,
    options
  );
}

async function printShipmentLabel(shipmentId, labelType) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.post(
    `${url}/shipments/${shipmentId}/print-label`,
    {
      label_type: labelType,
    },
    options
  );
}

async function trackShipment(shipmentId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return await axios.get(`${url}/shipments/${shipmentId}/track`, options);
}

export default {
  getAllServices,
  subscribe,
  updateConfigs,
  syncBatch,
  getBatch,
  toggleServiceActivation,
  refreshService,
  getShipments,
  estimateShipment,
  createShipment,
  createPickup,
  cancelShipment,
  cancelPickup,
  printShipmentLabel,
  trackShipment,
  editEstimation,
  destroyEstimation,
  getAllShipments,
  getShipment,
};
